export const Email = (props) => {
  const { size = 24, onClick, verticalAlign, marginLeft, marginRight, top, color = '#958B88', className = '' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        style={{ verticalAlign }}
        width={size}
        height={size}
        viewBox="0 0 1920 1920"
      >
        <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
          <path
            fill='white'
            fillRule="evenodd"
            d="M1920 428.266v1189.54l-464.16-580.146-88.203 70.585 468.679 585.904H83.684l468.679-585.904-88.202-70.585L0 1617.805V428.265l959.944 832.441L1920 428.266zM1919.932 226v52.627l-959.943 832.44L.045 278.628V226h1919.887z"
          ></path>
        </g>
      </svg>
    </span >
  );
};
